<form [formGroup]="userForm" fxLayout="row wrap" fxLayoutAlign="space-between">
  <div *ngIf="generalError" class="mat-error  mb-3">
    {{generalError?.message}}
  </div>

  <mat-form-field fxFlex="45">
    <mat-label>Email </mat-label>
    <input formControlName="email" matInput name="email" type="email">
    <mat-error *ngIf="userForm.controls.email?.errors?.pattern && !userForm.controls.email?.errors?.required">
      Please enter a valid email address
    </mat-error>
    <mat-error *ngIf="userForm.controls.email?.errors?.required">
      Field <strong>required</strong>
    </mat-error>
  </mat-form-field>

  <mat-form-field fxFlex="45">
    <mat-label>First name </mat-label>
    <input formControlName="firstName" matInput name="firstname" type="text">
    <mat-error *ngIf="userForm.controls.firstName?.errors?.required">
      Field <strong>required</strong>
    </mat-error>
  </mat-form-field>

  <mat-form-field fxFlex="45">
    <mat-label>Last name </mat-label>
    <input formControlName="lastName" matInput name="lastname" type="text">
    <mat-error *ngIf="userForm.controls.lastName?.errors?.required">
      Field <strong>required</strong>
    </mat-error>
  </mat-form-field>

  <mat-form-field fxFlex="45">
    <mat-label>Phone </mat-label>
    <input [dropSpecialCharacters]="false" [mask]="'+00 000 0*'" formControlName="phone" matInput name="phone"
      type="tel">
    <mat-error *ngIf="userForm.controls.phone?.errors?.pattern && !userForm.controls.phone?.errors?.required">
      Please enter a valid phone number
    </mat-error>
    <mat-error *ngIf="userForm.controls.phone?.errors?.required">
      Field <strong>required</strong>
    </mat-error>
  </mat-form-field>

  <mat-form-field fxFlex="45">
    <mat-label>Address </mat-label>
    <input [value]="_researcher.address ? _researcher.address : ''" formControlName="address" ngx-gp-autocomplete
      matInput name="address" type="text">
    <mat-error *ngIf="userForm.controls.address?.errors?.required">
      Field <strong>required</strong>
    </mat-error>
  </mat-form-field>

  <mat-form-field fxFlex="45">
    <mat-label>MAC Address </mat-label>
    <input formControlName="macAddress" matInput name="macAddress" type="text">
    <mat-error *ngIf="userForm.controls.macAddress?.errors?.required">
      Field <strong>required</strong>
    </mat-error>
    <mat-error *ngIf="userForm.controls.macAddress?.errors?.pattern">
      Enter a valid MAC address
    </mat-error>
  </mat-form-field>

  <mat-form-field fxFlex="45">
    <mat-label>Operating System </mat-label>
    <input formControlName="operatingSystem" matInput name="operatingSystem" type="text">
    <mat-error *ngIf="userForm.controls.operatingSystem?.errors?.required">
      Field <strong>required</strong>
    </mat-error>
  </mat-form-field>

  <mat-form-field fxFlex="45">
    <mat-label>Organization Name </mat-label>
    <input formControlName="organizationName" matInput name="organizationName" type="text">
    <mat-error *ngIf="userForm.controls.organizationName?.errors?.required">
      Field <strong>required</strong>
    </mat-error>
  </mat-form-field>

  <div fxFlex="100" fxLayout="row" fxLayoutAlign="end">
    <button (click)="onCancel()" mat-button>Cancel</button>
    <button (click)="saveUser()" [disabled]="userForm.invalid || saving " color="primary" mat-button>
      <i *ngIf="saving" class="fas fa-spinner fa-spin"></i>
      <ng-container *ngIf="!saving">Save</ng-container>
    </button>
  </div>

</form>